var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.$store.state.emp.id_empresa == 55)?_c('reporte_cxc'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }